// layout
import AdminLayout from "../../layout/Admin"
// redux
import { ModuloState } from '../../store/slices/modulo'
// componentes propios
import Noticias from '../../components/Noticias/NoticiasEdicion';
import Modulo from '../../components/Modulo/ModuloEdicion';

type Props = {
    modulo: ModuloState
}

const Admin = ({ modulo }: Props) => {

    return (
        <AdminLayout>
            {modulo.modulo === 0 ? <Noticias /> : <Modulo />}
        </AdminLayout>
    )
}

export default Admin;